export default __webpack_public_path__ + "static/media/closed-icon.4d1096c9.svg";